// exported selectors used with the useSelector hook

export const selectTheme = (state) => state.theme
export const selectEmployees = (state) => state.employees